import axios from "axios";

const BASE_URL = "https://dashboard.mragent.amgen.com/api";
// const BASE_URL = "http://agenticace-client-prod-dash-alb-437143424.us-east-2.elb.amazonaws.com/api"
//const BASE_URL = "https://api.agenticace-dashboard.pharmaace.ai"; // old prod link
// const BASE_URL = "http://localhost:8301";

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor — attach token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Response interceptor — handle 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const logoutRedirectUrl = localStorage.getItem("logout_redirect_url");

      localStorage.removeItem("auth_token");
      localStorage.removeItem("id_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("logout_redirect_url");

      // Redirect to login (works outside React components)
      window.location.href = logoutRedirectUrl ?? "/login";
    }

    return Promise.reject(error);
  },
);

export default apiClient;
